<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<!-- 返回按钮 -->
			<div class="back_left" @click="$router.back()"></div>
			<!-- 页面标题 -->
			<div class="big_tit">{{$t('user.myInvestment')}}</div>
		</div>
		<div class="total-main">
			<div class="money_box">
				<!-- 未回收本金 -->
				<div class="item">
					<div class="m-card">
						<p class="info">{{$t('user.uncollectedPrincipal')}}</p>
						<p class="money_num" v-html="data.on_money"></p>
					</div>
				</div>
				<!-- 未回收利息 -->
				<div class="item">
					<div class="m-card">
						<p class="info">{{$t('user.uncollectedInterest')}}</p>
						<p class="money_num" v-html="data.on_apr_money"></p>
					</div>
				</div>
				<!-- 累计收益 -->
				<div class="item">
					<div class="m-card">
						<p class="info">{{$t('user.cumulativeIncome')}}</p>
						<p class="money_num" v-html="data.ok_apr_money"></p>
					</div>
				</div>
			</div>
			<!-- 投资记录 -->
			<h3 class="notes_tit">{{$t('orders.record')}}</h3>
			<!-- 如果没有订单 -->
			<van-empty :description="$t('orders.noOrders')" v-if="empty" />
			<!-- 有订单时显示 -->
			<div class="scrollBox">
				<div class="notes_box" v-if="!empty" v-for="(i, index) in data.list" :key="index">
					<div class="timer">
						<span class="time">{{ i.start_time }}</span>
						<!-- 状态标签：未完成 -->
						<span class="tag ing" v-if="i.status == 0">{{$t('orders.unfinish')}}</span>
						<!-- 状态标签：已完成 -->
						<span class="tag finish" v-if="i.status == 1">{{$t('orders.finish')}}</span>
					</div>
					<div class="items-flex">
						<div class="flex_bd">
							<div class="item_div1">
								<!-- 动态语言字段展示 -->
								<p>{{ i[lang] }}</p>
							</div>
							<div class="item_div2">
								<div class="item_min">
									<p>{{ i.money }}</p>
									<p>{{$t('utils.investmentAmount')}}</p>
								</div>
								<div class="item_rate">
									<p>{{(i.money*i.rate/100).toFixed(2)}}</p>
									<p v-if="i.settlement_cycle=='end'">{{$t('utils.income')}}</p>
									<p v-if="i.settlement_cycle=='daily'">{{$t('utils.daily_income')}}</p>
								</div>
								<!-- 倒计时显示 -->
								<div class="item_day" v-if="i.status == 0">
									<p style="padding: 2px 0;">
										<!-- Vant 倒计时组件 -->
										<van-count-down :time="i.remaining_time * 1000" style="font-size: 12px; line-height: 16px;">
											<template #default="timeData">
												<span class="block">{{ timeData.days }}</span>
												<span class="colon">:</span>
												<span class="block">{{ timeData.hours }}</span>
												<span class="colon">:</span>
												<span class="block">{{ timeData.minutes }}</span>
												<span class="colon">:</span>
												<span class="block">{{ timeData.seconds }}</span>
											</template>
										</van-count-down>
									</p>
									<p><span class="iconfont icon-shijian text-red"></span> {{$t('utils.cycle')}}</p>
								</div>
								<!-- 如果状态为已完成，显示周期 -->
								<div class="item_day" v-if="i.status == 1">
									<p>{{ i.day }}{{$t('utils.day')}}</p>
									<p>{{$t('utils.cycle')}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue"; // 引入 Vue
import { Empty, CountDown } from "vant";
import Fetch from "../../utils/fetch"; // 引入封装的网络请求工具

Vue.use(Empty); // 使用 Vant 的 Empty 组件
Vue.use(CountDown); // 使用 Vant 的倒计时组件

export default {
	name: "order", // 组件名字
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn", // 当前语言
			data: {}, // 后端返回的数据
			empty: false, // 是否为空记录
		};
	},
	created() {
		this.$parent.footer("order"); // 调用父组件的方法设置底部导航
		this.start(); // 初始化请求数据
	},
	methods: {
		// 异步获取订单数据
		async start() {
			try {
				// 从后端接口获取数据
				const response = await Fetch("/user/order");
				this.data = response.data; // 赋值后端返回的订单数据
				this.empty = this.data.list.length === 0; // 判断记录是否为空
			} catch (error) {
				console.error("获取数据失败：", error);
			}
		},
		// 数据格式化（示例：万单位转换，备用方法）
		formatMoney(num) {
			num = parseFloat(num);
			if (num > 99999) {
				return `${(num / 10000).toFixed(2)} 万`;
			}
			return num.toFixed(2);
		},
	},
};
</script>

<style lang="less" scoped>
	.total-main{
		overflow: hidden;
	}
	.basic_wrap{
		padding-top: 44px;
	}
	.red_top_bg {
		top: 0;
		width: 100%;
		position: fixed;
		z-index: 15;
	}

	.money_box {
		background-color: #f7f7f7;
		display: flex;
		justify-content: space-around;
		padding:15px 5px;
		.item {
			width: 33.33%;
			padding:0 6px;
			text-align: center;
			.money_num {
				font-size: 14px;
				line-height: 25px;
				font-weight: bold;
				white-space: normal;
				word-break: normal;
				text-align: center;
				color: #ef5040;
			}

			.info {
				font-size: 14px;
				line-height: 20px;
				// margin-top: 5px;
				color: #ccc;
			}
		}
	}

	.notes_tit {
		width: 100%;
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		background: #FAFAFA;
		z-index: 2;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: -2px 2px 9px 2px rgba(160, 160, 160, 0.15);
		margin-bottom: 15px;
		.timer {
			background-color: #f5f5f5;
			padding: 10px 14px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.time{
				color: #999999;
			}
			.tag {
				font-style: normal;
				padding:8px 12px;
				border-radius: 5px;
				text-align: center;
				color: #FFFFFF;
				min-width: 60px;
			}

			.ing {
				background: #ff5c4f;
			}

			.finish {
				font-style: normal;
				background: #04c382;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			margin-bottom: 10px;
			font-size: 15px;
			p:nth-child(1) {
				width:auto;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				margin-left: 3%;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			>div {
				flex: 1;
				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #e82637;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				width: 110px;
				text-align: center;
				flex: unset;
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				margin-left: -15px;
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}
	.items-flex{
		display: flex;
		padding: 15px;
		.flex_bd{
			flex: 1;
			min-width: 0;
		}
	}
	.item-ico{
		font-size: 0;
		margin-right: 10px;
		margin-top: -4px;
	}
	.item-ico img{
		width: 28px;
		height: 28px;
	}
	.m-card{
		background-color: #FFFFFF;
		text-align: center;
		border-radius: 10px;
		box-shadow: 0 1px 8px rgba(0, 0, 0, .1);
		padding: 5px 5px;
		height: 75px;
		// max-height: 75px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}
	.total-bar{
		background-color: #FFFFFF;
		text-align: center;
		box-shadow: 0 1px 8px rgba(0, 0, 0, .1);
		padding: 15px 0;
		.tot-desc{
			color: #999;
			font-size: 12px;
		}
		.icon-time-circle{
			font-size: 14px;
		}
		.tot-cell{
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 10px;
		}
	}
	.item_day{
		/deep/ .van-count-down{
			display: flex;
			align-items: center;
		}
	}
	.colon {
	    margin: 0 1px;
	    color: #999;
	  }
	  .block {
	    display: inline-block;
	    width: 22px;
	    color: #333;
	    font-size: 12px;
		border-radius: 4px;
	    text-align: center;
	    background-color: #e5e5e5;
	  }
	
	
	
	
	
	
</style>
<style>
	
	.tot-cell  .icon-up{
		display: inline-block;
		animation:movetip 1s infinite
	}
	.tot-cell  .icon-down{
		display: inline-block;
		animation:movetip2 1s infinite
	}
	.color{
		animation:color 2s infinite
	}
	@keyframes movetip
	{
		from {transform:translateY(0);}
		to {transform:translateY(-5px);}
	}
	@keyframes movetip2
	{
		from {transform:translateY(0);}
		to {transform:translateY(5px);}
	}
	@keyframes color
	{
		0% {color: #000;}
		50% {color: #e82637;}
		100% {color: #04c382;}
	}
	
	
	
	
</style>
